import { Button } from '@chakra-ui/button'
import { Flex } from '@chakra-ui/layout'
import { Drawer, DrawerBody, DrawerContent, DrawerFooter, DrawerHeader, DrawerOverlay } from '@chakra-ui/modal'

import React from 'react'
import { useEffect } from 'react'
import { baseURL, ListaVendedoresAtivos } from '../../../../services/api'
import { ComponentExplicativo } from './ComponentExplicativo'
import { InputForm } from './Inputs/InputForm'
import { SelectStyled } from './styles'

export default function FiltroStatusPedido({
  open,
  onClose,
  onClick,
  changeInputField,
  FiltrarStatus,
  optionsTransp,
  optionsStatus,
  optionsPrazo,
  optionsGravacao,
  optionsEntregue,
  DespacharEmLote,
  codigo_usuario,
  isDisabled,
}) {
  const [optionsGravacoes, setOptionsGravacoes] = React.useState([])
  const [vendedores, setVendedores] = React.useState([])
  const [dados, setDados] = React.useState([])

  async function getDadosPdf() {
    const response = await baseURL.get('/pedido/resumo-producao')

    setDados(response.data)
  }

  console.log('DADOS', dados)

  useEffect(() => {
    getDadosPdf()
  }, [])

  useEffect(() => {
    //toda vez que apertar Enter chama o FiltrarStatus

    function handleEnter(event) {
      if (event.key === 'Enter') {
        FiltrarStatus()
      }
    }

    window.addEventListener('keydown', handleEnter)

    return () => {
      window.removeEventListener('keydown', handleEnter)
    }
  }, [])

  async function getVendedores() {
    try {
      const response = await ListaVendedoresAtivos.get()
      const data = response.data

      const vendedores = data.map((vendedor) => {
        return {
          value: vendedor.codigo_usuario,
          label: vendedor.nome_vendedor,
        }
      })

      setVendedores(vendedores)
    } catch (error) {
      console.log(Object.keys(error), error.message)
    }
  }

  React.useEffect(() => {
    const valueOptions = optionsGravacao.map((option) => {
      return {
        value: option.codigo_impressao,
        label: option.descricao_impressao,
      }
    })

    setOptionsGravacoes(valueOptions)

    getVendedores()
  }, [optionsGravacao])

  return (
    <>
      <Button
        onClick={onClick}
        bg="#414042"
        _hover={{
          filter: 'brightness(0.9)',
        }}
        color="white"
        disabled={isDisabled}
      >
        Mostrar Filtros
      </Button>
      <Drawer placement={'top'} onClose={onClose} isOpen={open}>
        <DrawerOverlay />
        <DrawerContent height="495px">
          <DrawerHeader borderBottomWidth="1px" textAlign="center">
            Filtro Status Pedido
          </DrawerHeader>
          <DrawerBody>
            <Flex flexDirection="column" gap={5}>
              <Flex gap={2} mt="1rem">
                <InputForm label="Pedido" onChange={(e) => changeInputField(e, 'input', 'pedido_selecionado')} />

                {[0, 30, 22, 21, 14, 12, 60, 66].includes(codigo_usuario) && (
                  <SelectStyled
                    placeholder="VENDEDOR"
                    options={vendedores}
                    onChange={(e) => changeInputField(e, 'select', 'vendedor_selecionado')}
                    isFocused
                  />
                )}

                <SelectStyled
                  placeholder="Personalização"
                  options={optionsGravacoes}
                  onChange={(e) => changeInputField(e, 'select', 'vendedor_selecionado')}
                  isFocused
                />
                <SelectStyled
                  placeholder="Prazo de produção"
                  options={optionsPrazo}
                  onChange={(e) => changeInputField(e, 'select', 'prazo_selecionado')}
                  isFocused
                />
                <SelectStyled
                  placeholder="Transportadora"
                  options={optionsTransp}
                  onChange={(e) => changeInputField(e, 'select', 'tipo_transportadora')}
                  isFocused
                />
              </Flex>
              <Flex gap={2}>
                <InputForm label="Data prevista de Despacho" type="date" onChange={(e) => changeInputField(e, 'input', 'data_relatorio')} />
                <SelectStyled
                  placeholder="Status do pedido"
                  options={optionsStatus}
                  onChange={(e) => changeInputField(e, 'select', 'status_selecionado')}
                />
                <SelectStyled
                  placeholder="ENTREGUE / NÃO ENTREGUE"
                  options={optionsEntregue}
                  onChange={(e) => changeInputField(e, 'select', 'entrega_selecionada')}
                  defaultValue={{ value: '0', label: 'TODOS' }}
                />

                <Button colorScheme="blue" w="150px" onClick={() => FiltrarStatus()}>
                  Filtrar
                </Button>
              </Flex>

              {[0, 30, 19, 22, 60, 66].includes(codigo_usuario) && (
                <Button colorScheme="blue" w="150px" m="auto" onClick={() => DespacharEmLote()}>
                  Despachar em lote
                </Button>
              )}
            </Flex>
            <ComponentExplicativo />
          </DrawerBody>
          <DrawerFooter borderTopWidth="1px">
            <Button variant="outline" mr={3} onClick={onClose}>
              Fechar filtro
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  )
}
